import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileQuestion, ShieldOff } from "lucide-react";

export function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <FileQuestion className="h-14 w-14 mx-auto text-muted-foreground mb-4" />
        <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">Error 404</div>
        <h1 className="font-heading font-bold text-4xl mt-2">Halaman tidak ditemukan</h1>
        <p className="text-sm text-muted-foreground mt-3">Alamat yang Anda tuju tidak tersedia atau telah dipindahkan.</p>
        <Link to="/dashboard"><Button className="rounded-full mt-6" data-testid="btn-back-home">Kembali ke Dashboard</Button></Link>
      </div>
    </div>
  );
}

export function Forbidden() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <ShieldOff className="h-14 w-14 mx-auto text-destructive mb-4" />
        <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">Error 403</div>
        <h1 className="font-heading font-bold text-4xl mt-2">Akses Ditolak</h1>
        <p className="text-sm text-muted-foreground mt-3">Peran Anda tidak memiliki hak untuk mengakses halaman ini.</p>
        <Link to="/dashboard"><Button className="rounded-full mt-6" data-testid="btn-back-dash">Kembali ke Dashboard</Button></Link>
      </div>
    </div>
  );
}
